import { n as e } from "./context-BrD4AniQ.js";
import { n as t, r as n } from "./constants-DOpa8YMW.js";
import { t as r } from "./esm-Be30MpcN.js";
import { t as i } from "./esm-k7KI3vER.js";
import { o as a, r as o, s } from "./maplibre-CUYkxr-D.js";
import { useCallback as c, useEffect as l, useRef as u, useState as d } from "react";
import { jsx as f, jsxs as p } from "react/jsx-runtime";
//#region src/components/Map/Root/BaseMap/Maptiler/translations.ts
var m = {
	en: {
		"AttributionControl.ToggleAttribution": "Toggle attribution",
		"AttributionControl.MapFeedback": "Map feedback",
		"FullscreenControl.Enter": "Enter fullscreen",
		"FullscreenControl.Exit": "Exit fullscreen",
		"GeolocateControl.FindMyLocation": "Find my location",
		"GeolocateControl.LocationNotAvailable": "Location not available",
		"LogoControl.Title": "MapLibre logo",
		"Map.Title": "Map",
		"Marker.Title": "Map marker",
		"NavigationControl.ResetBearing": "Reset bearing to north",
		"NavigationControl.ZoomIn": "Zoom in",
		"NavigationControl.ZoomOut": "Zoom out",
		"Popup.Close": "Close popup",
		"ScaleControl.Feet": "ft",
		"ScaleControl.Meters": "m",
		"ScaleControl.Kilometers": "km",
		"ScaleControl.Miles": "mi",
		"ScaleControl.NauticalMiles": "nm",
		"GlobeControl.Enable": "Enable globe",
		"GlobeControl.Disable": "Disable globe",
		"TerrainControl.Enable": "Enable terrain",
		"TerrainControl.Disable": "Disable terrain",
		"CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
		"CooperativeGesturesHandler.MacHelpText": "Use ⌘ + scroll to zoom the map",
		"CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
	},
	fr: {
		"AttributionControl.ToggleAttribution": "Afficher/Masquer l’attribution",
		"AttributionControl.MapFeedback": "Retour sur la carte",
		"FullscreenControl.Enter": "Passer en plein écran",
		"FullscreenControl.Exit": "Quitter le plein écran",
		"GeolocateControl.FindMyLocation": "Trouver ma position",
		"GeolocateControl.LocationNotAvailable": "Position non disponible",
		"LogoControl.Title": "Logo MapLibre",
		"Map.Title": "Carte",
		"Marker.Title": "Marqueur de carte",
		"NavigationControl.ResetBearing": "Réinitialiser l’orientation au nord",
		"NavigationControl.ZoomIn": "Zoomer",
		"NavigationControl.ZoomOut": "Dézoomer",
		"Popup.Close": "Fermer la fenêtre",
		"ScaleControl.Feet": "pi",
		"ScaleControl.Meters": "m",
		"ScaleControl.Kilometers": "km",
		"ScaleControl.Miles": "mi",
		"ScaleControl.NauticalMiles": "mn",
		"GlobeControl.Enable": "Activer le globe",
		"GlobeControl.Disable": "Désactiver le globe",
		"TerrainControl.Enable": "Activer le relief",
		"TerrainControl.Disable": "Désactiver le relief",
		"CooperativeGesturesHandler.WindowsHelpText": "Utilisez Ctrl + défilement pour zoomer sur la carte",
		"CooperativeGesturesHandler.MacHelpText": "Utilisez ⌘ + défilement pour zoomer sur la carte",
		"CooperativeGesturesHandler.MobileHelpText": "Utilisez deux doigts pour déplacer la carte"
	}
}, h = () => {
	let { current: t } = s(), { centerPinMarkerPoints: n, markerPoints: a, locationBoundary: o, setZoom: f, mapPadding: p } = e(), [m, h] = d(void 0), g = u(void 0), _ = c(() => {
		t && f(t.getZoom());
	}, [t, f]);
	return l(() => (_(), t?.on("zoom", _), () => {
		t?.off("zoom", _);
	}), [t, _]), l(() => {
		if (!t) return;
		let e = [];
		if (o !== void 0 && o.length > 0 ? e.push(...o) : a !== void 0 && a.length > 0 ? (e.push(...a), n && e.push(n)) : n !== void 0 && e.push(n), e.length === 0) return;
		let s = i(r(e));
		(!g.current || !s.every((e, t) => e === g.current?.[t])) && (g.current = s, h(s));
	}, [
		t,
		a,
		o,
		n
	]), l(() => {
		if (!t || m === void 0) return;
		let [e, n, r, i] = m, a = (r - e) * .1 || .001, o = (i - n) * .1 || .001;
		t.fitBounds([[e - a, n - o], [r + a, i + o]], {
			padding: p,
			maxZoom: 17,
			duration: 700
		});
	}, [
		t,
		m,
		p
	]), null;
};
function g({ children: r }) {
	let { mapProvider: i, locale: s, center: c, zoom: l = n.zoom, minZoom: u, maxZoom: d, pitch: g = n.pitch, bearing: _ = n.bearing, cooperativeGestures: v = n.cooperativeGestures, zoomPosition: y } = e();
	return i.name === "maptiler" ? /* @__PURE__ */ p(a, {
		initialViewState: {
			...c,
			zoom: l,
			pitch: g,
			bearing: _
		},
		cooperativeGestures: v,
		minZoom: u,
		maxZoom: d,
		mapStyle: `https://api.maptiler.com/maps/${i.theme || t.maptiler}/style.json?key=${i.apiKey}`,
		locale: m[s],
		children: [
			/* @__PURE__ */ f(h, {}),
			y && /* @__PURE__ */ f(o, { position: y }),
			r
		]
	}) : null;
}
//#endregion
export { g as default };
